export default "__VITE_ASSET__CayZzWSF__"